import { PsButtonTuner } from "stencilSetup";
import { PopupFileDto } from "enrollment/features/ToDoList/types";
import { PlanFileLinkStyled } from "./PlanContentFileStyled";

interface PlanContentFileProps {
  file: PopupFileDto;
  apiHost: string;
}

export const PlanContentFile = ({
  file,
  apiHost,
}: PlanContentFileProps) => {
  const href = file.url;
  const fileName = file.file_name;

  function downloadFile(){
    window.open(apiHost + href, '_blank');
  };

  return (
    <PlanFileLinkStyled>
      <PsButtonTuner
        buttonId={`download-file-${file.storage_file_id}`}
        data-testid={`download-file-${file.storage_file_id}`}
        level="tertiary"
        label={fileName}
        onClick={() => downloadFile()}
      >
      </PsButtonTuner>
    </PlanFileLinkStyled>
  );
};
